<button
    [ngClass]="{ 
        'no-background': hideBackground,
        'size-medium': size === 'medium',
        'size-large': size === 'large',
     }"
    (click)="onClick()"
>
    <span *ngIf="icon">
        <app-icon
            *ngIf="icon"
            [icon]="icon"
            colorCss="--content-primary" 
            [sizeCss]="sizeCss">
        </app-icon>
    </span>
</button>
